import React, { Component } from 'react'

import { Navbar, Nav, NavDropdown, Image } from 'react-bootstrap';
import { Link } from "react-router-dom";

export default class NavBar extends Component {
    state = {
        isTop: true,
        hasHero: this.props.hasHero,
    };

    componentDidMount() {
        document.addEventListener('scroll', () => {
            const isTop = window.scrollY < 1;
            if (isTop !== this.state.isTop) {
                this.setState({ isTop })
            }
        });
    }

    render() {
        return (
            <div>
                <Navbar variant={this.state.isTop ? (this.state.hasHero ? 'dark navbar-large navbar-transparent' : 'dark navbar-small') : 'dark navbar-small'} expand="sm" fixed="top">
                    <Navbar.Brand as={Link} alt="ISSC" to="/"><Image alt="ISSC Logo" src="https://firebasestorage.googleapis.com/v0/b/issc-vn.appspot.com/o/images%2Fissc_logo_transparent_white.png?alt=media&token=870b3e3c-d91d-44ed-b49f-2198701c2887" width="50" height="50" className={this.state.isTop ? (this.state.hasHero ? 'navbar-logo-large' : 'navbar-logo-small') : 'navbar-logo-small'} /></Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="mr-auto">
                            <Nav.Link as={Link} to="/">Home</Nav.Link>
                            <Nav.Link as={Link} to="/sponsorship">Sponsorship</Nav.Link>
                                <NavDropdown title="Past Competitions" id="basic-nav-dropdown">
                                    <NavDropdown.Item as={Link} to="/past-competitions/2016">2016</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/past-competitions/2017">2017</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/past-competitions/2018">2018</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/past-competitions/2019">2019</NavDropdown.Item>
                                </NavDropdown>
                        </Nav>
                        <Nav className="ml-auto">
                            <Nav.Link as={Link} to="/contact">Contact</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
                {this.state.hasHero ? "" : <div><br /><br /><br /></div>}
            </div>
        )
    }
}
